import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text, Icon } from 'roo-ui/components';

const RoomTypeDisplayMeta = React.memo(({ maxOccupantCount }) => {
  if (!maxOccupantCount) return null;

  return (
    <Flex alignItems="center">
      <Icon name="people" color="greys.steel" size={18} mb="-3px" />
      <Text fontSize="base" color="greys.steel" ml="2">
        Sleeps {maxOccupantCount}
      </Text>
    </Flex>
  );
});

RoomTypeDisplayMeta.displayName = 'RoomTypeDisplayMeta';

RoomTypeDisplayMeta.propTypes = {
  maxOccupantCount: PropTypes.number,
};

RoomTypeDisplayMeta.defaultProps = {
  maxOccupantCount: null,
};

export default RoomTypeDisplayMeta;
